import { useNavigate } from "react-router-dom";

import type { CreateUserRequest, UserId } from "@thalamos/haven-common";

import api from "../../api/index.js";
import type { CreateUserOutcome } from "../../components/CreateUserDialog/CreateUserDialog.js";

/**
 * Creates an account and opens the page of the one it reached — new, or the
 * existing one it was added to — at the path this audience opens accounts at.
 */
export const useCreateUser = (accountPath: (userId: UserId) => string) => {
  const navigate = useNavigate();

  return async (request: CreateUserRequest): Promise<CreateUserOutcome> => {
    const response = await api.user.create(request);

    if (response.status === 409) {
      return "exists";
    }

    if (response.status !== 201 || !("id" in response.data)) {
      return "failed";
    }

    navigate(accountPath(response.data.id));
    return "created";
  };
};
